"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setAnonymousId = exports.getAnonymousId = exports.reset = exports.group = exports.track = exports.page = exports.alias = exports.identify = exports.init = void 0;
exports.setDebug = setDebug;
const constants_1 = require("./constants");
const event_queue_1 = require("./event-queue");
const persistence_1 = require("./persistence");
const utils_1 = require("./utils");
const sendEvent = (method, args) => {
    if (['track', 'page'].includes(method)) {
        // Identify the `properties` argument if it exists
        const pagePropertiesIndex = args.findIndex(arg => typeof arg === 'object');
        if (pagePropertiesIndex !== -1) {
            args[pagePropertiesIndex] = Object.assign(Object.assign({}, (0, persistence_1.getSuperProperties)()), args[pagePropertiesIndex]);
        }
    }
    // @ts-expect-error - The error is expected since TypeScript cannot combine all of the method types with all of the different method signatures
    // For similar scenarios, see https://github.com/microsoft/TypeScript/issues/33591
    window.rudderanalytics[method](...args);
};
const events = new event_queue_1.EventQueue();
const sendOrQueueEvent = (method, args) => {
    if ((0, utils_1.isRudderstackInitialized)()) {
        return sendEvent(method, args);
    }
    events.enqueue(method, args);
};
let debug;
function setDebug(fn) {
    debug = fn;
}
/**
 * @throws Error
 */
const init = (cfg) => {
    if (!(0, utils_1.isBrowser)()) {
        return Promise.reject(new Error('@hbf/analytics: not supported outside browser'));
    }
    if ((0, utils_1.isRudderstackInitialized)()) {
        debug === null || debug === void 0 ? void 0 : debug({ message: 'WARNING: Rudderstack is already initialized' });
        return;
    }
    const { writeKey, dataPlaneUrl, configUrl, loadOptions, cdnUrl, onReady } = cfg.rudderstack;
    if ((0, utils_1.isEmpty)(writeKey)) {
        throw new Error('@hbf/analytics: missing writeKey');
    }
    if ((0, utils_1.isEmpty)(dataPlaneUrl)) {
        throw new Error('@hbf/analytics: missing dataPlaneUrl');
    }
    if ((0, utils_1.isEmpty)(configUrl)) {
        throw new Error('@hbf/analytics: missing configUrl');
    }
    debug === null || debug === void 0 ? void 0 : debug({ message: 'Rudderstack library loading...' });
    return Promise.resolve().then(() => __importStar(require('@rudderstack/analytics-js'))).then(({ RudderAnalytics }) => {
        debug === null || debug === void 0 ? void 0 : debug({ message: 'Rudderstack library loaded' });
        window.rudderanalytics = new RudderAnalytics();
        const loadOptionsExtended = Object.assign(Object.assign({}, loadOptions), { configUrl, destSDKBaseURL: (0, utils_1.getSDKBaseURL)(cdnUrl, constants_1.INTEGRATIONS_FOLDER_PATH, loadOptions === null || loadOptions === void 0 ? void 0 : loadOptions.lockIntegrationsVersion), pluginsSDKBaseURL: (0, utils_1.getSDKBaseURL)(cdnUrl, constants_1.PLUGINS_FOLDER_PATH, loadOptions === null || loadOptions === void 0 ? void 0 : loadOptions.lockPluginsVersion) });
        debug === null || debug === void 0 ? void 0 : debug({
            message: 'Rudderstack loading...',
            loadOptions: loadOptionsExtended,
        });
        window.rudderanalytics.load(writeKey, dataPlaneUrl, loadOptionsExtended);
        window.rudderanalytics.ready(() => {
            debug === null || debug === void 0 ? void 0 : debug({ message: 'Rudderstack ready' });
            onReady === null || onReady === void 0 ? void 0 : onReady();
            events.batchDequeue(event => {
                const [method, ...args] = event;
                sendEvent(method, args);
            });
        });
    });
};
exports.init = init;
const identify = (...args) => {
    debug === null || debug === void 0 ? void 0 : debug({ message: 'identify', args });
    sendOrQueueEvent('identify', args);
};
exports.identify = identify;
const alias = (...args) => {
    debug === null || debug === void 0 ? void 0 : debug({ message: 'alias', args });
    sendOrQueueEvent('alias', args);
};
exports.alias = alias;
const page = (...args) => {
    debug === null || debug === void 0 ? void 0 : debug({ message: 'page', args });
    sendOrQueueEvent('page', args);
};
exports.page = page;
const track = (...args) => {
    debug === null || debug === void 0 ? void 0 : debug({ message: 'track', args });
    sendOrQueueEvent('track', args);
};
exports.track = track;
const group = (...args) => {
    debug === null || debug === void 0 ? void 0 : debug({ message: 'group', args });
    sendOrQueueEvent('group', args);
};
exports.group = group;
const reset = (...args) => {
    debug === null || debug === void 0 ? void 0 : debug({ message: 'reset', args });
    (0, persistence_1.resetSuperProperties)();
    sendOrQueueEvent('reset', args);
};
exports.reset = reset;
const getAnonymousId = options => {
    const isInitialized = (0, utils_1.isRudderstackInitialized)();
    debug === null || debug === void 0 ? void 0 : debug({ message: 'getAnonymousId', options, isInitialized });
    if (!isInitialized) {
        throw new Error('@hbf/analytics: getAnonymousId is called while Rudderstack is not ready');
    }
    return window.rudderanalytics.getAnonymousId(options);
};
exports.getAnonymousId = getAnonymousId;
const setAnonymousId = (...args) => {
    debug === null || debug === void 0 ? void 0 : debug({ message: 'setAnonymousId', args });
    sendOrQueueEvent('setAnonymousId', args);
};
exports.setAnonymousId = setAnonymousId;
//# sourceMappingURL=analytics.js.map